import React from 'react';
import { withTranslation } from 'react-i18next';
import ButtonWrapper from '../components/common/ButtonWrapper';
import { t } from 'i18next';
import { getErrorMessage } from '../utils';
import { compose } from 'redux';
import connect from 'react-redux/es/connect/connect';
import i18n from '../i18n';

const ErrorPage = ({ history, t, errorData, errorCode }) => {
  if (errorCode && !errorData && i18n.exists(`error.page.${errorCode}.msg`))
    errorData = { message: `error.page.${errorCode}.msg` };

  //errorCode available means we can go to previous page (example: on 404, react router redirect does not set on history the wrong path)
  //errorData available means we need to ignore the previous page (the one that gave the error)
  let stepsToGoBack = errorCode ? -1 : -2;

  return (
    <div>
      <h3>{t('error.page.generic.title')}</h3>
      <p>{t(getErrorMessage(errorData) || 'error.page.generic.msg')}</p>
      <ButtonWrapper
        type="button"
        label={t('page.home.title')}
        key="backHomeButton"
        primary
        onClick={() => {
          history.push('/');
        }}
      />
      <ButtonWrapper
        type="button"
        label={t('go.back.button')}
        key="goBackButton"
        primary
        onClick={() => {
          history.go(stepsToGoBack);
        }}
      />
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  errorData: state.common.errorData,
  errorCode: ownProps.match.params.errorCode,
});

export default React.memo(compose(withTranslation(), connect(mapStateToProps, null))(ErrorPage));
